import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FrequencyCreator from './FrequencyCreator'
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import days from './days.json'
import { LangContext } from "../LangContext.jsx";
class CfdiDocumentTemplate extends Component {
    constructor() {
        super();
        this.state = {
            mimes:[],
            selectedMimes:[5],
            frequencyType:'once',
            period:'Única',
            every:1,
            ReferDayName:'Primero',
            monthFrequencyType:'frequency',
            dayOfWeek:1,
            dayOfWeekName:'Lunes',
            monthOfYear:1,
            monthOfYearName:'Enero',
            dayOfMonth:0,
            day:1,
            dayName:'Lunes',
            ReferDay:1,
            repeatEvery:1,
            hasTemplate:false,
            repeatOn:1,
            repeatOnName:'dias',
            cicles:1,
            ends:'never',
            title: 'Nómina Masivo',
            templateTitleExists: false,
            templateTitleMessage: '',
            checkingTemplateTitle: false,
        };
        this.checkboxRef = React.createRef(false);
        this.templateTitleTimer = null;
    }
    updateParentState = (updatedState) => {
        this.setState(updatedState);
    }
    async componentDidMount() {
        await this.getMimes()
    }

    handleTemplateTitleChange = (e) => {
        const value = e.target.value;
        this.setState({ title: value }, () => this.scheduleTemplateTitleCheck());
    }

    scheduleTemplateTitleCheck = () => {
        const title = (this.state.title || '').trim();

        if (this.templateTitleTimer) {
            clearTimeout(this.templateTitleTimer);
        }

        if (title.length < 3) {
            this.setState({ templateTitleExists: false, templateTitleMessage: '', checkingTemplateTitle: false });
            return;
        }

        this.setState({ checkingTemplateTitle: true });
        this.templateTitleTimer = setTimeout(() => {
            this.checkTemplateTitleAvailability(title);
        }, 450);
    }

    checkTemplateTitleAvailability = async (title) => {
        try {
            const res = await axios.post('/api/documents/check-title', { title });
            const exists = Boolean(res?.data?.exists);
            const message = res?.data?.message || '';
            this.setState({
                templateTitleExists: exists,
                templateTitleMessage: message,
                checkingTemplateTitle: false,
            });
        } catch (e) {
            this.setState({ checkingTemplateTitle: false });
        }
    }

    async getMimes() {
        const res = await axios.get('/api/mimes')
        this.setState({mimes: res.data})
    }

    createDocumentTemplate = ()=>{ 
        if (this.state.templateTitleExists) {
            swal.fire({
                text: this.state.templateTitleMessage || 'Ya existe una plantilla con este nombre.',
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
            })
            return;
        }

        const params = JSON.stringify({
            active:1,
            every: this.state.every,
            repeat_on: this.state.repeatOn,
            ends: this.state.ends,
            cicles: this.state.cicles,
            day_of_week: this.state.dayOfWeek,
            month_frequency_type: this.state.monthFrequencyType,
            refer_day: this.state.ReferDay,
            day: this.state.day,
            day_of_month: this.state.dayOfMonth,
            month_of_year: this.state.monthOfYear,
            instructions:this.state.instructions,
            title: this.state.title,
            frequency: this.state.frequencyType,
            size: 10,
            is_automatic: 0,
            cfdi_id: 3, 
            type_id:4, 
            mimes: [10] ,
            fields: [] ,
            required: true, 
            period: this.state.period, 
            displayCfdiInput:this.state.displayCfdiInput,
            template:this.state.template,
            deleteTemplate: this.state.deleteTemplate,
        }) 
        
        axios.post( '/api/documents', params, {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            swal.fire({
                text: "Guardado",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) { 
                 window.location.href = '/documents'; 
            });
        }).catch((error) => {
            console.log(error)
            window.unblockUI();
            const message = getErrorsMessage(error); 
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }
    render() {
        return (
            <>
            <div className="card card-custom gutter-b">
                <div className="card-body">
                    <div className="d-flex">
                        <div className="flex-grow-1">
                            <div className="row justify-content-center text-left"> 
                                <div className="col-sm-6 form-group">
                                    <label className="text-left">Nombre</label>
                                    <input id="title" type="text" className="form-control" name="title" value={this.state.title || ''} onChange={this.handleTemplateTitleChange} autoFocus />
                                    {this.state.templateTitleExists && (
                                        <div className="text-danger font-weight-bold mt-2">
                                            {this.state.templateTitleMessage || 'Ya existe una plantilla con este nombre.'}
                                        </div>
                                    )}
                                    { this.state.frequency_key == 'yearly' &&
                                        <small className="text-muted"> {this.state.period} </small>
                                    }
                                </div>
                                <div className="col-sm-6 form-group">
                                    <FrequencyCreator updateParentState={this.updateParentState} category={this.props.category} documentType={5} />
                                </div> 
                                <div  className="col-md-12">
                                    <label className="text-left">Formatos</label>
                                    <div className="checkbox-inline form-group">
                                        {this.state.mimes.map(({id, title}) => {
                                            return(
                                                <label
                                                    key={id}
                                                    className={"checkbox checkbox-lg checkbox-square checkbox-disabled "  }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        name="extensions"
                                                        value={id}
                                                        checked={this.state.selectedMimes.includes(id)}
                                                        disabled={true}
                                                    />
                                                    <span></span>
                                                    {title}
                                                </label>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div className="col-sm-6 ">
                                    <div className="form-group mt-5">
                                        <label className="text-left">Tipo</label>
                                        <select  className="form-control" name="cfdi_id"  disabled>
                                            <option value="0">Nómina</option> 
                                        </select> 
                                    </div>
                                </div>
                                <div className="col-sm-6  d-flex align-items-center">
                                <div className="row ">
                                {/* Columna izquierda con checkbox */}
                                <div className="col-sm-1 d-flex align-items-center  ">
                                    <input type="checkbox" checked={true} readOnly={true} />
                                </div>

                                {/* Columna derecha con párrafo y enlace */}
                                <div className="col-sm-11">
                                    <p className='text-muted no-margin-bottom '>Se adjunta plantilla base establecido por el sistema</p>
                                    <a href='/assets/media/template/PlantillaCfdiExppedify.xlsx'>Descargar plantilla base</a>
                                </div>
                                </div>
                                </div> 
                                <div className="col-sm-12">
                                    <b>Máximo 10 MB por archivo</b>
                                    <p className='text-muted'></p>
                                    <div className='instructions-container'>
                                        <b>
                                            1. Descargar la plantilla base y llenar los datos requeridos.  <br></br>
                                            2. Crear un archivo ZIP que contenga la plantilla .XLS junto con el número de archivos XMLs correspondientes al RFC y periodo que se especifica en la plantilla base.<br></br> 
                                            3. Asegurarse que el ZIP contenga un archivo .XLS y archivos de tipo .XML y que estos sean diferentes entre sí.<br></br>
                                            4. Los archivos .XML deberán ser de tipo de CFDI solicitado.
                                        </b>
                                    </div> 
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card card-custom gutter-b">
                <div className="card-body">
                <strong className="mb-3">Información que se extrae del CFDI de tipo Nómina</strong>
                    <div className="card mt-3 p-9 bg-light-light"> 
                        <div className="row align-left" >
                            <div className="col-sm-8"> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Total  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Sub Total  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Descuento  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Fecha  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Folio  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Lugar Expedicion  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Metodo Pago  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Moneda  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> No Certificado  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Tipo Cambio  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Exportacion  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Version  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Serie  </span>
                                </div> 
                                <div className="mb-2">
                                    <span> <i className="fa fa-check icon text-primary mr-5 font-size-xs"></i> </span>
                                    <span className="d-inline-block"> Forma Pago  </span>
                                </div> 
                            </div> 
                        </div> 
                    </div>
                </div>
            </div>
            <div className="row justify-content-end mt-6">
                <div className="col-sm-8 text-right"> 
                    <a href="/documents" className="btn btn-lg btn-secondary">
                        Cancelar
                    </a>
                    <button id="btnPublish" onClick={ ()=> { this.createDocumentTemplate()}} type="button" className="btn btn-lg btn-primary ml-4">
                        Guardar
                    </button>
                </div>
            </div>
            </>
        )
    }
}

export default CfdiDocumentTemplate;

if (document.getElementById('CfdiDocumentTemplate')) {
    ReactDOM.render(<CfdiDocumentTemplate/>, document.getElementById('CfdiDocumentTemplate'));
}
